import {BasePalette} from '#core/application/modules/base-palette.js';
import {generateSkeletonPart} from '#core/application/modules/tiles/skeleton-part/index.js';
import {generateToggleButtonRow} from '#core/application/modules/tiles/button/toggle-button/index.js';

export function inPlayPageFactory(PALETTE) {
    return {
        InPlayMenu: {
            rootContainer: {
                style: {
                    fontFamily: BasePalette.palette.FONT_FAMILY,
                    padding: '8px 0',
                    _mobile_padding: '8px 8px 0 8px',
                },
            },
            navigationMenu: generateToggleButtonRow(PALETTE.INPLAY_SPORTS_SELECTOR),
            navigationMenuSkeleton: {
                linkPlaceholder: generateSkeletonPart(PALETTE.INPLAY_SPORTS_SELECTOR_SKELETON_PART),
            },
        },
    };
}
